import React from 'react';

var UserContent = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'user-content' }, children);
};

export { UserContent };
